const CITY = "Калининград";
const STREET = "Ленинский проспект, 57";
// Карточка организации в Яндекс Картах: yandex.ru/maps/org/<YANDEX_ORG>/
const YANDEX_ORG = "barbershop_99/238470646407";
const LATITUDE = 54.713782;
const LONGITUDE = 20.506858;
const OPENS = "11:00";
const CLOSES = "20:00";

export const CONTACTS = {
	address: {
		city: CITY,
		country: "RU",
		postalCode: "236006",
		full: `г. ${CITY}, ${STREET}`,
		short: STREET,
	},
	map: {
		latitude: LATITUDE,
		longitude: LONGITUDE,
		url: `https://yandex.ru/maps/org/${YANDEX_ORG}/`,
		apiKey: "d6f3b938-55b2-4b76-9f13-3703a8eaba1e",
	},
	hours: {
		days: "Пн-Вс",
		daysOfWeek: [
			"Monday",
			"Tuesday",
			"Wednesday",
			"Thursday",
			"Friday",
			"Saturday",
			"Sunday",
		],
		opens: OPENS,
		closes: CLOSES,
		time: `${OPENS}-${CLOSES}`,
		short: `Ежедневно ${OPENS}-${CLOSES}`,
	},
	phone: "+7 (995) 325-45-99",
} as const;
